import React, { useMemo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import ShopPageCard from "./ShopPageCard";
import HomeFilter from "../HomeFilter/HomeFilter";
import Pagination from "../HelperComponents/Pagination/Pagination";
import { getSegmentsFilterList, getSpecialProducts } from "../../actions/productsActions";
import { storageList, sortProductsByWarehouse } from "../../helpers/functions";
import "./ShopPage.scss";

const PAGE_SIZE = 8;
const QUERY_PARAM = 'spage';
const FILTER_PARAM = 'filters';

const StockBlock = ({ getStorages, makeRequest, goToProd, history, location }) => {
    const dispatch = useDispatch();

    const {
        special_products: specialProducts,
        loading,
        filter_list: filterList
    } = useSelector(state => state.products);


    const params = new URLSearchParams(location.search);
    const currentPage = parseInt(params.get(QUERY_PARAM)) || 1;
    const selectedFilters = params.get(FILTER_PARAM) ? params.get(FILTER_PARAM).split(',') : [];

    useEffect(() => {
        dispatch(getSegmentsFilterList());
    }, [dispatch]);

    useEffect(() => {
        dispatch(getSpecialProducts(selectedFilters, currentPage, PAGE_SIZE));
    }, [dispatch, currentPage, JSON.stringify(selectedFilters)]);

    const handlePageChange = (page) => {
        // Pagination component handles the URL update
    };

    const handleFilterChange = (values) => {
        const params = new URLSearchParams(location.search);
        if (values && values.length > 0) {
            params.set(FILTER_PARAM, values.join(','));
        } else {
            params.delete(FILTER_PARAM);
        }
        params.set(QUERY_PARAM, 1);
        history.push({ search: params.toString() });
    };

    const sortedResults = useMemo(() =>
        sortProductsByWarehouse(specialProducts?.results),
        [specialProducts?.results]);

    const pageCount = specialProducts ? Math.ceil(specialProducts.count / PAGE_SIZE) : 0;


    return (
        <div className="mb40">
            <header className="content_header filter_wrapper">
                <div className="title_page">Акции и скидки</div>
                <HomeFilter
                    handleFilter={handleFilterChange}
                    initialSelect={selectedFilters}
                    list={filterList}
                />
            </header>
            <div className="catalog_product">
                {loading ? (
                    <p>Идет загрузка товара...</p>
                ) : (
                    <>
                        {sortedResults && sortedResults.length > 0 ? (
                            sortedResults.map((el, idx) => {
                                let sum = 0;
                                if (el.storage_quantity) {
                                    el.storage_quantity.forEach(item => {
                                        sum += item.quantity || 0;
                                    });
                                }
                                return (
                                    <ShopPageCard
                                        key={el.id || idx}
                                        el={el}
                                        idx={idx}
                                        sum={sum}
                                        goToProd={goToProd}
                                        getStorages={getStorages}
                                        productsStoragesName={'special_products'}
                                        makeRequest={makeRequest}
                                    />
                                );
                            })
                        ) : (
                            <p>Нет товаров</p>
                        )}
                    </>
                )}
            </div>

            {!loading && pageCount > 1 && (
                <Pagination
                    pageCount={pageCount}
                    onPageChange={handlePageChange}
                    forcePage={currentPage - 1}
                    queryParam={QUERY_PARAM}
                />
            )}
        </div>
    );
};

export default withRouter(StockBlock);